module.exports = __webpack_public_path__ + "img/24.1fb93691.jpg";